import React,{Component, useCallback,useState} from 'react'
import { Box, Button, Container, Grid, Link, TextField, Typography } from '@mui/material';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { Diversity1 } from '@mui/icons-material';
import FormControl from '@mui/material/FormControl';
import CloseSharpIcon from '@mui/icons-material/CloseSharp';
import { render } from '@testing-library/react';
import Modal, {
  ModalBody,
  ModalFooter,
  ModalHeader,
  ModalTitle,
  ModalTransition,
} from '@atlaskit/modal-dialog';
import Paper from '@mui/material/Paper';
import LinearProgress from '@mui/material/LinearProgress';
import { getUser } from '../util';
export default class Reset extends React.Component{
  localData
  partymail;
  constructor(){
    super()
    this.state={
      modalOpen:false,
      style : {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 1000,
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
      },
      email:'',
      mail:'',
      progress:false
    }
  }
   maskEmail=(email) =>{   
    const [localPart, domainPart] = email.split('@');
    
   
    const firstThreeChars = localPart.slice(0, 3);
    
    
    const maskedLocalPart = firstThreeChars + '*'.repeat(localPart.length - 3);
    
    
    return maskedLocalPart + '@' + domainPart;
}
  componentDidMount=()=>{
    this.partymail = JSON.parse(localStorage.getItem('party_mail'));
    
    if (localStorage.getItem('party_mail')) {
      const id = this.partymail.mail
      const maskedEmail = this.maskEmail(id);
      //console.log(maskedEmail);
      this.setState({email:maskedEmail})
      this.setState({mail:this.partymail.mail})
    }
  }
  onButtonClick=()=>{
    this.setState({modalOpen:true})  
  
  }
  onModelCose=()=>{
    this.setState({modalOpen:false})
  }
  validateEmail=(email)=> {
    const re = /^(([^<>()[\]\\.,;:\s@"]+(\.[^<>()[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    return re.test(String(email).toLowerCase());
  }

  onSendLink=()=>{
   
    if(this.state.email===''){
      alert('Plz Enter Valid Email')
    }else if(!this.validateEmail(this.state.mail)){
      alert('Please Enter Valid MailId')
    }
    else{
      this.setState({progress:true})
      let json_data={emailId:this.state.mail}
      fetch(`eadmin/v1/set/forgot_password`, {
      method: 'POST',
      headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json',
      },
      body:(JSON.stringify(json_data)),
      }).then((response) => response.json())
      .then((responseJson) => {
        if(responseJson.status ){
          localStorage.setItem("EMAILID", this.state.mail);
          this.onButtonClick()
          this.setState({email:'',progress:false})
        } 
        else{
          this.setState({progress:false})
          alert(responseJson.errorMsg)
        }
      }).catch((error) => {
        this.setState({progress:false})
        alert(error)
      });
    }
  }
  render(){
    return(
      <>
        {this.state.progress && <LinearProgress color="secondary"/>}
          <Paper sx={{ p: 2, marginTop: '10%',marginLeft:'28%', maxWidth: '50%', flexGrow: 1 ,}}>
            <div>
              <title>Reset Password</title>
            </div>
            <Box
              component="main"
              sx={{
                alignItems: 'center',
                display: 'flex',
                flexGrow: 1,
                minHeight: '100%',
                marginTop:'8%'
              }}
            >
              <Container maxWidth="sm">
                <form>
                  <Box sx={{ my: 3 }}>
                    <Typography
                      color="textPrimary"
                      variant="h4" >
                      Forget Password
                    </Typography>
                   <Typography
                      color="textSecondary"
                      gutterBottom
                      variant="body2">
                    </Typography>
                  </Box>
                  <TextField
                    fullWidth
                    label="Email ID"
                    type="email"
                    variant="outlined"
                    value={this.state.email}
                    onChange={(evt)=>{this.setState({email:evt.target.value})
                  setTimeout(() => {
                    if(this.state.email!==''){
        
                      let data={mail:this.state.email}
                      
                      localStorage.setItem('party_mail',JSON.stringify(data))

                      this.setState({mail:this.state.email})
                  
                    }
                  }, 100);}}
                  />
                  <Box sx={{ py: 2 }}>
                    <Button
                      color="primary"
                      fullWidth
                      size="large"
                      variant="contained"
                      onClick={this.onSendLink}
                    >Submit</Button>
                  </Box>
                  <Typography
                    color="textSecondary"
                    variant="body2"
                  >
                    Don&apos;t have an account?
                    {' '}
                      <a
                      href='/'
                        variant="subtitle2"
                        underline="hover"
                        sx={{
                          cursor: 'pointer'
                        }}
                      >
                       Login
                      </a>
                  </Typography>
                </form>
              </Container>
            </Box>
          </Paper>
          <ModalTransition>
            {this.state.modalOpen && (
              <Modal onClose={this.onModelCose} >
                <ModalHeader>
                  <ModalTitle>Forget Password</ModalTitle>
                </ModalHeader>
                <ModalBody>
                  <ul>
                  <li>Please Check The Mail To Verify The Link</li><br/>
                  <li>Link is valid for 5 minutes only</li>
                  </ul>
                </ModalBody>
                <ModalFooter>
                  <Button appearance="primary" onClick={this.onModelCose} autoFocus>OK</Button>
                </ModalFooter>
              </Modal>
           )}
          </ModalTransition>
        </>
      )
    }
}

        
